// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* purgecss start ignore */

.g5A7sgfkUHwxfUSt_lcN {
  height: calc(100vh - 4rem);
}

/* purgecss end ignore */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeBackground": `g5A7sgfkUHwxfUSt_lcN`
};
export default ___CSS_LOADER_EXPORT___;
